import { __assign } from "tslib";
import { EmissionFactorInclude } from './EmissionFactor';
var emissionFactorQuery = {
    where: {
        deleted: false,
        OR: [{ usageEndDate: null }, { usageEndDate: { gt: new Date() } }],
        usageStartDate: { lte: new Date() },
    },
    include: EmissionFactorInclude,
};
export var EmissionFactorQueryWithOrg = function (organizationId) { return (__assign({ deleted: false, usageStartDate: { lt: new Date() } }, (organizationId
    ? {
        AND: [
            { OR: [{ usageEndDate: null }, { usageEndDate: { gt: new Date() } }] },
            { OR: [{ organizationId: null }, { organizationId: organizationId }] },
        ],
    }
    : {
        AND: [
            { OR: [{ usageEndDate: null }, { usageEndDate: { gt: new Date() } }] },
            { OR: [{ organizationId: null }] },
        ],
    }))); };
export var ActivityDataSourceInclude = {
    emissionFactors: emissionFactorQuery,
    activityDataSourceTypes: true,
    parent: {
        include: {
            emissionFactors: emissionFactorQuery,
            parent: {
                include: {
                    parent: true,
                    emissionFactors: emissionFactorQuery,
                },
            },
        },
    },
};
export function ActivityDataSourceIncludeEmissionFactors(withEmissioFactors) {
    if (withEmissioFactors === void 0) { withEmissioFactors = true; }
    return __assign(__assign({}, (withEmissioFactors ? { emissionFactors: emissionFactorQuery } : {})), { activityDataSourceTypes: true, activityDataSourceMappings: {
            include: { scope: true },
        }, parent: {
            include: __assign(__assign({}, (withEmissioFactors ? { emissionFactors: emissionFactorQuery } : {})), { parent: {
                    include: __assign({ parent: true }, (withEmissioFactors ? { emissionFactors: emissionFactorQuery } : {})),
                } }),
        } });
}
export var ActivityDataSourceWithFactorsInclude = {
    activityDataSourceTypes: true,
    parent: {
        include: {
            emissionFactors: emissionFactorQuery,
            parent: {
                include: {
                    parent: true,
                    emissionFactors: emissionFactorQuery,
                },
            },
        },
    },
    children: {
        include: {
            emissionFactors: emissionFactorQuery,
            children: {
                include: {
                    emissionFactors: emissionFactorQuery,
                    children: {
                        include: {
                            emissionFactors: emissionFactorQuery,
                        },
                    },
                },
            },
        },
    },
    emissionFactors: emissionFactorQuery,
};
export var ActivityDataSourceWhereQuery = function (subcategoryId, calculationMethodId, organizationId, metadata, parentId) { return (__assign(__assign({ activityDataSourceMappings: {
        some: { calculationMethodId: calculationMethodId, subcategoryId: subcategoryId },
    }, OR: [
        {
            emissionFactors: { some: EmissionFactorQueryWithOrg(organizationId) },
            OR: [
                { organizations: { some: { id: organizationId } } },
                { organizations: { none: { id: undefined } } },
            ],
        },
        {
            key: 'default-other',
            OR: [
                { organizations: { some: { id: organizationId } } },
                { organizations: { none: { id: undefined } } },
            ],
        },
    ] }, (metadata ? { metadata: metadata } : {})), { disabled: false, parentId: parentId !== null && parentId !== void 0 ? parentId : null })); };
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var ActivityDataSourceWithChildrenInclude = function (_a) {
    var organizationId = _a.organizationId, calculationMethodId = _a.calculationMethodId, subcategoryId = _a.subcategoryId, _b = _a.emissionFactor, emissionFactor = _b === void 0 ? false : _b, _c = _a.lean, lean = _c === void 0 ? false : _c, adsIds = _a.adsIds;
    var efquery;
    if (lean) {
        efquery = __assign(__assign({}, emissionFactorQuery), { include: { supplier: true } });
    }
    else {
        efquery = emissionFactorQuery;
    }
    return __assign(__assign({ activityDataSourceTypes: true, activityDataSourceMappings: {
            include: { scope: true },
        }, parent: {
            include: __assign(__assign({}, (emissionFactor ? { emissionFactors: efquery } : {})), { parent: {
                    include: __assign({ parent: true }, (emissionFactor ? { emissionFactors: efquery } : {})),
                } }),
        } }, (emissionFactor ? { emissionFactors: efquery } : {})), { children: {
            where: __assign(__assign(__assign({}, (calculationMethodId && subcategoryId
                ? {
                    activityDataSourceMappings: {
                        some: {
                            calculationMethodId: calculationMethodId,
                            subcategoryId: subcategoryId,
                        },
                    },
                    emissionFactors: { some: EmissionFactorQueryWithOrg(organizationId) },
                }
                : {})), { disabled: false }), (organizationId
                ? {
                    OR: [
                        { organizations: { some: { id: organizationId } } },
                        { organizations: { none: { id: undefined } } },
                    ],
                }
                : {})),
            include: {
                activityDataSourceTypes: true,
                parent: true,
                children: {
                    where: __assign(__assign(__assign(__assign({}, (adsIds ? { id: { in: adsIds } } : {})), (calculationMethodId && subcategoryId
                        ? {
                            activityDataSourceMappings: {
                                some: {
                                    calculationMethodId: calculationMethodId,
                                    subcategoryId: subcategoryId,
                                },
                            },
                        }
                        : {})), { disabled: false }), (organizationId
                        ? {
                            OR: [
                                { organizations: { some: { id: organizationId } } },
                                { organizations: { none: { id: undefined } } },
                            ],
                        }
                        : {})),
                    include: __assign(__assign({ activityDataSourceTypes: true, parent: {
                            include: __assign(__assign({}, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: true }),
                        } }, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { children: {
                            where: __assign(__assign(__assign(__assign({}, (adsIds ? { id: { in: adsIds } } : {})), (calculationMethodId && subcategoryId
                                ? {
                                    activityDataSourceMappings: {
                                        some: {
                                            calculationMethodId: calculationMethodId,
                                            subcategoryId: subcategoryId,
                                        },
                                    },
                                }
                                : {})), { disabled: false }), (organizationId
                                ? {
                                    OR: [
                                        { organizations: { some: { id: organizationId } } },
                                        { organizations: { none: { id: undefined } } },
                                    ],
                                }
                                : {})),
                            include: __assign(__assign({ activityDataSourceTypes: true }, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: {
                                    include: __assign(__assign({}, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: {
                                            include: __assign({ parent: true }, (emissionFactor && !lean ? { emissionFactors: efquery } : {})),
                                        } }),
                                }, children: {
                                    where: __assign(__assign(__assign(__assign({}, (adsIds ? { id: { in: adsIds } } : {})), (calculationMethodId && subcategoryId
                                        ? {
                                            activityDataSourceMappings: {
                                                some: {
                                                    calculationMethodId: calculationMethodId,
                                                    subcategoryId: subcategoryId,
                                                },
                                            },
                                        }
                                        : {})), { disabled: false }), (organizationId
                                        ? {
                                            OR: [
                                                { organizations: { some: { id: organizationId } } },
                                                { organizations: { none: { id: undefined } } },
                                            ],
                                        }
                                        : {})),
                                    include: {
                                        activityDataSourceTypes: true,
                                        parent: {
                                            include: __assign(__assign({}, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: {
                                                    include: __assign(__assign({}, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: {
                                                            include: __assign(__assign({}, (emissionFactor && !lean ? { emissionFactors: efquery } : {})), { parent: true }),
                                                        } }),
                                                } }),
                                        },
                                    },
                                } }),
                        } }),
                },
            },
        } });
};
//# sourceMappingURL=ActivityDataSource.js.map